import { useState, useEffect } from "react";
import { Collapse, Descriptions, Space, Button } from "antd";
import { customBaseUrl, httpGet, httpPut } from "../../../../store/http";
import Swal from "sweetalert2";
import { hideLoader, showLoader } from "../../../../utils/loader";
import { NotificationManager } from "react-notifications";
import { AlertEmpty } from "./alert-empty";

const special_fields = {
  accountStatus: {
    backgroundColor: "#fff1f0",
    color: "#cf1322",
    border: "1px solid #ffa39e",
    padding: "2px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 500,
    textTransform: "capitalize",
    display: "inline-block",
  },
  kycLevel: { color: "inherit" },
};

export const CustomerAccounts = ({ id }) => {
  const [userWallets, setUserWallets] = useState([]);
  const [selectedWalletAccount, setSelectedWalletAccount] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchWallets();
  }, [id]);

  const fetchWallets = async () => {
    if (!id) return;
    try {
      setLoading(true);
      const res = await httpGet(
        `${customBaseUrl.authUrl}/api/v1/accounts/user/${id}/details`,
      );
      if (res?.success && Array.isArray(res.data.accounts)) {
        setUserWallets(res?.data?.accounts);
      }
    } catch (err) {
      console.error("Failed to fetch user wallets", err);
    } finally {
      setLoading(false);
    }
  };

  const handleWalletAccountActivation = async (isActive) => {
    const { value: formValues } = await Swal.fire({
      title: `Enter reason and remarks for wallet ${isActive ? "activation" : "deactivation"}`,
      html:
        '<input id="swal-input1" class="swal2-input" placeholder="Reason">' +
        '<input id="swal-input2" class="swal2-input" placeholder="Remarks">',
      focusConfirm: false,
      showCancelButton: true,
      preConfirm: () => {
        const reason = document.getElementById("swal-input1").value;
        const remarks = document.getElementById("swal-input2").value;
        if (!reason || !remarks) {
          Swal.showValidationMessage(`Please enter both reason and remarks`);
        }
        return { reason, remarks };
      },
    });

    if (formValues) {
      const { reason, remarks } = formValues;
      showLoader();

      const selectedWallet = userWallets.find(
        (w) => w.accountNumber === selectedWalletAccount,
      );
      if (!selectedWallet) {
        hideLoader();
        NotificationManager.error("Selected wallet not found.");
        return;
      }

      const accountId = selectedWallet.id; // Assuming the wallet object has an 'id' property for accountId

      const response = await httpPut(
        `${customBaseUrl.authUrl}/admin/users/accounts/${accountId}/status`,
        {
          isActive,
          reason,
          remarks,
        },
      );
      hideLoader();
      if (response.success === true || response.status === true) {
        NotificationManager.success(
          `Wallet account ${isActive ? "activated" : "deactivated"} successfully!`,
        );
        fetchWallets(); // Refresh wallet details
      } else {
        NotificationManager.error(
          response.error?.message || response.message || "An error occurred",
        );
      }
    }
  };

  // const fetchWalletDetails = useCallback(async (accountNumber) => {
  //   if (!accountNumber) return;
  //   setWalletDetailsLoading(true);
  //   setWalletDetailsError(null);
  //   try {
  //     const res = await httpGet(
  //       `${customBaseUrl.tranv2}/api/v1/transactions/account/${accountNumber}/details`,
  //     );
  //     if (res?.success) {
  //       setWalletDetails(res.data.data);
  //     } else {
  //       setWalletDetailsError(
  //         res?.message || "Failed to fetch wallet details.",
  //       );
  //     }
  //   } catch (err) {
  //     setWalletDetailsError("An error occurred while fetching wallet details.");
  //     console.error(err);
  //   } finally {
  //     setWalletDetailsLoading(false);
  //   }
  // }, []);

  if (!loading && !userWallets.length) {
    return <AlertEmpty text="Sorry, no account was found for this account." />;
  }

  return (
    <Collapse accordion>
      {userWallets.map((wallet) => {
        return (
          <Collapse.Panel
            header={
              <div
                onClick={() => setSelectedWalletAccount(wallet.accountNumber)}
                style={{
                  display: "flex",
                  textTransform: "uppercase",
                  justifyContent: "space-between",
                }}
              >
                <span>
                  {wallet.accountName || `Wallet ${wallet.accountNumber}`}
                </span>
                <span>{wallet.accountNumber}</span>
              </div>
            }
            key={wallet.accountNumber}
          >
            <Descriptions bordered column={2}>
              {Object.entries(wallet || {}).map(([key, value]) => {
                const style = special_fields[key];

                return (
                  <Descriptions.Item
                    key={key}
                    label={key
                      .replace(/([A-Z])/g, " $1")
                      .replace(/^./, (str) => str.toUpperCase())}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        textTransform: "uppercase",
                        ...style,
                      }}
                    >
                      {typeof value === "boolean"
                        ? value
                          ? "Yes"
                          : "No"
                        : String(value).replace(/_/g, " ")}
                    </span>
                  </Descriptions.Item>
                );
              })}
            </Descriptions>

            <Space style={{ marginTop: 16 }}>
              <Button>Generate Statement</Button>

              {wallet?.accountStatus.toLowerCase() === "active" ? (
                <Button danger onClick={() => handleWalletAccountActivation(false)}>Deactivate</Button>
              ) : (
                <Button type="default" onClick={() => handleWalletAccountActivation(true)}>
                  Activate
                </Button>
              )}
            </Space>
          </Collapse.Panel>
        );
      })}
    </Collapse>
  );
};
